import { combineReducers } from "@reduxjs/toolkit"
import { avaliacaoFormularioReducer } from "./Avaliacao.reducer.formulario"
import { avaliacaoListaReducer } from "./Avaliacao.reducer.lista";


export const avaliacaoReducer = combineReducers({
  formulario: avaliacaoFormularioReducer,
  lista: avaliacaoListaReducer,
});